import { useEffect, useState, useCallback } from 'react';
import { IDirectLineToken as IDirectLineToken } from '../core/Interfaces';

const getTokenEndpoint = (): URL | null => {
  const locationUrl = new URL(window.location.href);
  const tokenEndpoint = locationUrl.searchParams.get('tokenEndpoint');
  if (!tokenEndpoint) {
    return null;
  }

  return new URL(tokenEndpoint);
};

const tokenEndpoint = getTokenEndpoint();

export default function useFetchDirectLineToken() {
  const [token, setToken] = useState<IDirectLineToken | null>(null);

  const fetchToken = useCallback(async () => {
    if (!tokenEndpoint) return;

    try {
      const response = await fetch(tokenEndpoint);
      if (!response.ok) {
        console.error('Error fetching token', response);
        return;
      }

      const tokenData = (await response.json()) as IDirectLineToken;
      setToken(tokenData);
    } catch (error) {
      console.error('Error fetching token:', error);
    }
  }, []);

  useEffect(() => {
    void fetchToken();
  }, [fetchToken]);

  return { token };
}
